const reg = {
  isEmail:
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  isPhone:
    /^((19[0-9])|(17[0-9])|(16[0-9])|(14[0-9])|(13[0-9])|(15[^4,\D])|(18[0-9]))\d{8}$/,
  isName: /^[\u4E00-\u9FA5A-Za-z]+$/,
  isCode: /[0-9]{4}/,
  isSixCode: /[0-9]{6}/,
  isTaxNumber: /[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}/,
};

// 邮箱
export function isEmail(val) {
  return reg.isEmail.test(val);
}
// 手机
export function isPhone(val) {
  return reg.isPhone.test(val);
}
// 姓名
export function isName(val) {
  return reg.isName.test(val);
}
// 4位验证码
export function isCode(val) {
  return reg.isCode.test(val);
}

// 6位验证码
export function isSixCode(val) {
  return reg.isSixCode.test(val);
}

// 税务号
export function isTaxNumber(val) {
  return reg.isTaxNumber.test(val);
}

